import { cn } from "@gettactic/helpers";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon, MinusIcon } from "lucide-react";
import * as React from "react";
import { Label } from "../controls/Label/Label";

export type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
>;

// purpose of this is to display hovered checkbox in storybook
export const checkboxHoverClassBase =
  "outline outline-[3px] outline-neutral-50";
const checkboxHoverClass = checkboxHoverClassBase
  .split(" ")
  .map((c) => `hover:${c} group-hover:${c}`)
  .join(" ");

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, ...props }, ref) => (
  <div className="flex items-center">
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-md",
        "border border-neutral-400",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-black",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:border-none data-[state=checked]:bg-black data-[state=checked]:text-white",
        "data-[state=indeterminate]:border-none data-[state=indeterminate]:bg-black data-[state=indeterminate]:text-white",
        checkboxHoverClass,
        className
      )}
      id={props.id}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}
      >
        {props.checked === "indeterminate" ? (
          <MinusIcon className="h-4 w-4" />
        ) : (
          <CheckIcon className="h-4 w-4" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
    <Label htmlFor={props.id} className="ml-2 text-normal">
      {props.children}
    </Label>
  </div>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
